import React from 'react';
import styled from 'styled-components';
import { array } from 'prop-types';

import ProductItem from './ProductItem';
import ProductItemContact from './ProductItemContact';

const ListContainer = styled.section`
   margin: 0px;
   width: 100%;

   @media(min-width: 1000px) {
    display: flex;
    width: 100%;
    margin: 40px 0px 0px;
   }
`;

const ProductsList = ({ products }) => (
  <ListContainer>
    {products.map(product =>
      (product.type !== 'contact' ?
        (
          <ProductItem key={product.type} product={product} />
        ) : (
          <ProductItemContact />
        )
      ))}
  </ListContainer>
);

ProductsList.propTypes = {
  products: array,
};

ProductsList.defaultProps = {
  products: [],
};

export default ProductsList;
